/**
 * Set Password Page
 * Reached from an invite/forgot email link carrying a ?token= query param.
 */

import { useSearchParams, Link } from 'react-router';
import { SetPasswordForm } from '@/modules/auth';

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (!token) {
    return (
      <div className='space-y-4'>
        <h2 className='text-xl font-semibold text-foreground'>Invalid link</h2>
        <p className='text-sm text-muted-foreground'>
          This password link is invalid or has expired. Please request a new one.
        </p>
        <Link to='/forgot-password' className='text-primary hover:underline text-sm'>
          Request a new link
        </Link>
      </div>
    );
  }

  return (
    <div>
      <h2 className='text-xl font-semibold text-foreground mb-2'>Set your password</h2>
      <p className='text-sm text-muted-foreground mb-6'>Choose a password to activate your account.</p>
      <SetPasswordForm token={token} />
    </div>
  );
}
